function ValidateEventDates(event) {
    if(event.type === "fd100"){
        return (new Date(event.inscriptions_start_date) < new Date(event.inscriptions_end_date))
    }else{
        return (new Date(event.inscriptions_start_date) < new Date(event.inscriptions_end_date))
        && (new Date(event.inscriptions_end_date) < new Date(event.main_date))
        && (new Date(event.inscriptions_end_date) < new Date(event.online_date))
    }
}
export {ValidateEventDates};
